import React from 'react';
import styles from './Contact.module.css';

import deck1Image from '../assets/images/deck1.webp';
import deck2Image from '../assets/images/deck2.webp';
import deck3Image from '../assets/images/deck3.webp';
import deck4Image from '../assets/images/deck4.webp';
import deck5Image from '../assets/images/deck5.webp';
import deck6Image from '../assets/images/deck6.webp';
import deck7Image from '../assets/images/deck7.webp';
import deck8Image from '../assets/images/deck8.webp';
import deck9Image from '../assets/images/deck9.webp';
import stairImage from '../assets/images/stair.webp';

const sanitizeInput = (value) => {
  return value.replace(/[^0-9.]/g, '');
};

const StepSix = ({ formData, handleMeasurementChange, errors }) => {
  const deckImages = {
    'Deck 1': deck1Image,
    'Deck 2': deck2Image,
    'Deck 3': deck3Image,
    'Deck 4': deck4Image,
    'Deck 5': deck5Image,
    'Deck 6': deck6Image,
    'Deck 7': deck7Image,
    'Deck 8': deck8Image,
    'Deck 9': deck9Image,
  };

  const measurements = {
    'Deck 1': ['A', 'B', 'C'],
    'Deck 2': ['A', 'B', 'C'],
    'Deck 3': ['A', 'B', 'C'],
    'Deck 4': ['A', 'B', 'C', 'D'],
    'Deck 5': ['A', 'B', 'C', 'D'],
    'Deck 6': ['A', 'B', 'C', 'D'],
    'Deck 7': ['A', 'B', 'C'],
    'Deck 8': ['A', 'B', 'C'],
    'Deck 9': ['A', 'B', 'C'],
  };

  const selectedDeck = formData.deckChoice;
  const deckMeasurements = measurements[selectedDeck] || [];

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <div className={styles.step}>
      <h2 className={styles.stepSixHeading}>Step 6: Enter Deck Measurements</h2>
      <div className={styles.imageContainer}>
        <img
          src={deckImages[selectedDeck]}
          alt={selectedDeck}
          className={styles.deckImage}
          aria-labelledby="deck-image-label"
        />
      </div>
      <p id="deck-image-label">Please input the measurements in inches.</p>
      <div className={styles.measurementContainer}>
        {deckMeasurements.map((measurement) => (
          <div key={measurement} className={styles.inputGroup}>
            <label htmlFor={`deckMeasurement${measurement}`}>Measurement {measurement}:</label>
            <input
              type="number"
              id={`deckMeasurement${measurement}`}
              name={measurement}
              value={formData.deckMeasurements[measurement]}
              onChange={(e) => {
                const sanitizedValue = sanitizeInput(e.target.value);
                handleMeasurementChange({ target: { name: measurement, value: sanitizedValue } });
              }}
              className={styles.narrowInput}
              min="0"
              step="0.01"
              onKeyDown={handleKeyDown}
              aria-describedby={`deckMeasurement${measurement}-error`}
            />
            {errors[`deckMeasurements${measurement}`] && (
              <p id={`deckMeasurement${measurement}-error`} className={styles.error}>
                {errors[`deckMeasurements${measurement}`]}
              </p>
            )}
          </div>
        ))}
      </div>
      {formData.stairRailingRequired && selectedDeck !== 'Deck 2' && selectedDeck !== 'Deck 3' && (
        <>
          <h3>Stair Measurements</h3>
          <div className={styles.imageContainer}>
            <img
              src={stairImage}
              alt="Stair Measurements"
              className={styles.deckImage}
              aria-labelledby="stair-image-label"
            />
          </div>
          <div className={styles.stairMeasurements}>
            <div className={styles.measurementContainer}>
              <div className={styles.inputGroup}>
                <label htmlFor="stairMeasurementA">Stair Measurement A:</label>
                <input
                  type="number"
                  id="stairMeasurementA"
                  name="stairA"
                  value={formData.deckMeasurements.stairA}
                  onChange={(e) => {
                    const sanitizedValue = sanitizeInput(e.target.value);
                    handleMeasurementChange({ target: { name: 'stairA', value: sanitizedValue } });
                  }}
                  className={styles.narrowInput}
                  min="0"
                  step="0.01"
                  onKeyDown={handleKeyDown}
                  aria-describedby="stairMeasurementA-error"
                />
                {errors.deckMeasurementsStairA && (
                  <p id="stairMeasurementA-error" className={styles.error}>
                    {errors.deckMeasurementsStairA}
                  </p>
                )}
              </div>
              <div className={styles.inputGroup}>
                <label htmlFor="stairMeasurementB">Stair Measurement B:</label>
                <input
                  type="number"
                  id="stairMeasurementB"
                  name="stairB"
                  value={formData.deckMeasurements.stairB}
                  onChange={(e) => {
                    const sanitizedValue = sanitizeInput(e.target.value);
                    handleMeasurementChange({ target: { name: 'stairB', value: sanitizedValue } });
                  }}
                  className={styles.narrowInput}
                  min="0"
                  step="0.01"
                  onKeyDown={handleKeyDown}
                  aria-describedby="stairMeasurementB-error"
                />
                {errors.deckMeasurementsStairB && (
                  <p id="stairMeasurementB-error" className={styles.error}>
                    {errors.deckMeasurementsStairB}
                  </p>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default StepSix;